import React, { useState, useEffect, useContext } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { DataContext } from "../../../context/DataContext";
import { getToken } from "../../../api/Account";
import { getColocacionSemanalAsync } from "../../../api/Dashboard";
import { simpleMessage } from "../../../helpers/Helpers";
import { chartTextColor, chartGridColor } from "../../../theme";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
  Tooltip
);

const ColocacionSemanal = ({ selectedSucursal }) => {
  const [labels, setLabels] = useState([]);
  const [colocacion, setColocacion] = useState([]);

  const { setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);
  const dayName = (fecha) =>
    ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"][
      new Date(fecha).getDay()
    ];

  const lineColor = isDarkMode ? "rgba(90,140,255,1)" : "rgba(54, 162, 235, 1)";
  const lineFill = isDarkMode ? "rgba(90,140,255,.35)" : "rgba(54, 162, 235, 0.2)";
  const textColor = chartTextColor(isDarkMode);
  const gridColor = chartGridColor(isDarkMode);

  const graphicData = {
    labels: labels,
    datasets: [
      {
        datalabels: { color: lineColor },
        label: "Colocacion",
        data: colocacion,
        backgroundColor: [lineFill],
        borderColor: [lineColor],
        pointStyle: "circle",
        pointRadius: 8,
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    aspectRatio: 5,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("es-NI", {
                style: "currency",
                currency: "NIO",
              }).format(context.parsed.y);
            }
            return label;
          },
        },
      },

      legend: {
        position: "top",
        align: "center",
        labels: { color: textColor },
      },
      title: {
        display: false,
      },
    },

    elements: {
      line: {
        borderJoinStyle: "round",
      },
    },

    scales: {
      x: {
        ticks: { color: textColor },
        grid: { color: gridColor },
      },
      y: {
        ticks: {
          color: textColor,
          callback: (value) => {
            return new Intl.NumberFormat("es-NI", {
              style: "currency",
              currency: "NIO",
            }).format(value);
          },
        },
        grid: { color: gridColor },
        beginAtZero: true,
      },
    },
  };

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getColocacionSemanalAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      let dias = [];
      let coloc = [];

      result.data.result.map((item) => {
        dias.push(dayName(item.fecha));
        coloc.push(item.colocacion);
      });

      setLabels(dias);
      setColocacion(coloc);

      setIsLoading(false);
    })();
  }, [selectedSucursal]);

  return (
    <div>
      <Line options={options} data={graphicData} />
    </div>
  );
};

export default ColocacionSemanal;
